export default __webpack_public_path__ + "static/media/Label_Food_inv.b89bc410.png";